/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentPhone', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-phone',
        replace: true,
        scope: {
          formObj: "=",
          formScope: "=",
          isRequired: '=?'
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {
          var self = this;

          if (typeof self.isRequired === 'undefined') {
            self.isRequired = true;
          }
        }]
      };

    }]);
}());